import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { debounce } from "lodash";
import { fetchParentRoles } from "redux/actions/RolesAndPermissionsAction";
import CommonSubHeader from "components/commonSubHeader/CommonSubHeader";
import CommonTable from "components/commonTable/CommonTable";
import Loader from "components/loader/Loader";
import ParentPermissionsModal from "./ParentPermissionsModal";

export default function RolesAndPermissions() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { parentRoles, loading } = useSelector((state) => state.rbacReducer);

  // Search & Pagination State
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Parent permissions modal
  const [permModalOpen, setPermModalOpen] = useState(false);
  const [selectedParent, setSelectedParent] = useState(null);

  useEffect(() => {
    dispatch(fetchParentRoles());
  }, []);

  // ── Handlers ──────────────────────────────────────────────────────────────

  const handleViewSubRoles = (role) => {
    navigate("/roles-permissions/sub-roles", { state: { parentRole: role } });
  };

  const handleViewAndUpdate = (role) => {
    setSelectedParent(role);
    setPermModalOpen(true);
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const onSearch = debounce((e) => {
    setSearch(e);
    setPage(0);
  }, 500);

  const filteredRoles = parentRoles.filter((role) =>
    role.name?.toLowerCase().includes(search.toLowerCase()),
  );

  const paginatedRoles = filteredRoles.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const tableData = {
    header: [
      { label: "Role", key: "name" },
      { label: "Platform", key: "platform" },
      { label: "Business Type", key: "businessType" },
      { label: "Role Type", key: "roleType" },
      { label: "Sub Roles", key: "subRoles" },
      { label: "Permissions", key: "permissions" },
    ],
    body: paginatedRoles,
    totalCount: filteredRoles.length,
  };

  return (
    <Box className="mb20">
      <Box className="mb30">
        <CommonSubHeader
          filter={false}
          onSearchQuery={onSearch}
          search={search}
          showDateFilter={false}
        />
      </Box>

      {loading && !parentRoles.length ? (
        <Loader height={"60vh"} />
      ) : (
        <CommonTable
          data={tableData}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          onViewSubRoles={handleViewSubRoles}
          onViewUpdatePermissions={handleViewAndUpdate}
          tabName={"roles-permissions"}
        />
      )}

      {/* ── Parent Permissions Modal ─────────────────────────────── */}
      <ParentPermissionsModal
        open={permModalOpen}
        onClose={() => setPermModalOpen(false)}
        parentRole={selectedParent}
      />
    </Box>
  );
}
